import moment from 'moment';
import { ComponentStates } from '../../enums/component-states';

export const getShipDate = (date, dateFormat) => {
  return moment(date, dateFormat)
    .utc(true)
    .set({
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0,
    })
    .toISOString();
};

export const BuildFulfillmentPlanForMAS = (orderNumber, restrictions, shipTos = [], trackingNumber = '') => {
  // Deducing following restrictions from labelConfiguration
  // Need to update fulfillmentplan restrictions for finer control
  const disableCarrierDropdown = restrictions?.labelConfiguration?.componentState === ComponentStates.Hidden;
  const disableNotifyMarketplace = restrictions?.labelConfiguration?.componentState === ComponentStates.Hidden;
  const disableNotifyCustomer = restrictions?.labelConfiguration?.componentState === ComponentStates.Hidden;

  return {
    orderNumber,
    deductInventory: false,
    disableCarrierDropdown,
    disableNotifyCustomer,
    disableNotifyMarketplace,
    recipient: shipTos[0] ? shipTos[0].name : '',
    notifyCustomer: !disableNotifyCustomer,
    notifyMarketplace: !disableNotifyMarketplace,
    shipDate: getShipDate(),
    trackingNumber,
  };
};

export const stopPropagation = (e) => e?.stopPropagation();
